import { useState } from 'react';
import { FaPlus, FaStickyNote, FaCalendarAlt, FaUserPlus, FaFileContract, FaMapMarkedAlt, FaHandshake } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const QuickActionsDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);

  const quickActions = [
    {
      icon: <FaStickyNote className="mr-2" />,
      label: 'New Note',
      to: '/notes?create=true'
    },
    {
      icon: <FaCalendarAlt className="mr-2" />,
      label: 'New Activity',
      to: '/schedule?create=true'
    },
    {
      icon: <FaUserPlus className="mr-2" />,
      label: 'New Contact',
      to: '/contacts?create=true'
    },
    {
      icon: <FaFileContract className="mr-2" />,
      label: 'New Contract',
      to: '/contracts?create=true'
    },
    {
      icon: <FaHandshake className="mr-2" />,
      label: 'New Proposal',
      to: '/proposals?create=true'
    },
    {
      icon: <FaMapMarkedAlt className="mr-2" />,
      label: 'New Plot',
      to: '/plots?create=true'
    }
  ];

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-center w-10 h-10 rounded-full bg-primary text-white hover:bg-opacity-90 focus:outline-none"
        title="Quick Actions"
      >
        <FaPlus className="w-4 h-4" />
      </button>

      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute right-0 mt-2 w-56 max-w-[calc(100vw-1rem)] rounded-md shadow-lg bg-white dark:bg-boxdark border border-stroke dark:border-strokedark z-50">
            <div className="py-1">
              {quickActions.map((action) => (
                <Link
                  key={action.to}
                  to={action.to}
                  className="flex min-h-11 items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700 transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  {action.icon}
                  {action.label}
                </Link>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default QuickActionsDropdown;
